import { axios } from 'common/axios';

import { TicketType } from 'common/enum/ticket-type.enum';
import { NotifierType } from 'common/enum/notifier-type.enum';

export const getTicketingSystemFields = async (
  application: any,
): Promise<any> => {
  const { data } = await axios.get(
    `/api/integrations/v1/ticketing/${application}/fields/`,
  );

  return data;
};

export const getSearchedTableOptions = async ({
  filter,
  tableName,
  serviceName,
  searchedText,
}: {
  filter: any;
  tableName: string;
  serviceName: string;
  searchedText: string;
}): Promise<any> => {
  const { data } = await axios.get(
    `/api/integrations/v1/ticketing/${serviceName}/lookup/`,
    {
      params: {
        table_name: tableName,
        starts_with_value: searchedText,
        ...(filter && { filter }),
      },
    },
  );

  return data;
};

export const completeTransaction = async (
  integrationType: TicketType | NotifierType,
  credential: any,
): Promise<any> => {
  const { data } = await axios.post(
    `/api/integrations/v1/connect/${integrationType}/complete/`,
    credential,
  );

  return data;
};

export const getIntegration = async (): Promise<any> => {
  const { data } = await axios.get('/api/integrations/v1/', {});

  return data;
};

export const deleteIntegrationWorkflow = async (
  integrationId: string,
): Promise<any> => {
  const { data } = await axios.delete(
    `/api/integrations/v1/workflows/${integrationId}/delete/`,
  );

  return data;
};

export const deleteIntegration = async (
  integrationId: string,
): Promise<any> => {
  const { data } = await axios.delete(
    `/api/integrations/v1/${integrationId}`,
    {},
  );

  return data;
};

export const updateIntegration = async (
  integrationId: string,
  credentials: any,
): Promise<any> => {
  const { data } = await axios.put(`/api/integrations/v1/${integrationId}`, {
    credentials: credentials,
  });

  return data;
};

export const createFormIntegration = async (integration: any): Promise<any> => {
  const { data } = await axios.post('/api/integrations/v1/', integration, {});

  return data;
};

export const fetchNotificationsTemplates = async (
  filter: any,
): Promise<any> => {
  const urlSearchParamsString = new URLSearchParams(filter).toString();
  const queryString = urlSearchParamsString ? `?${urlSearchParamsString}` : '';

  const { data } = await axios.get(
    `/api/notifications-templates${queryString}`,
  );

  return data;
};

export const updateNotificationTemplate = async (
  template: any,
): Promise<any> => {
  const { data } = await axios.put(
    '/api/notifications-templates',
    template,
    {},
  );

  return data;
};

export const insertNotificationTemplate = async (
  template: any,
): Promise<any> => {
  const { data } = await axios.post(
    '/api/notifications-templates',
    template,
    {},
  );

  return data;
};

export const deleteNotificationTemplate = async (
  templateId: string,
): Promise<any> => {
  const { data } = await axios.delete(
    `/api/notifications-templates/${templateId}`,
  );

  return data;
};

export const fetchIntegrationFields = async ({
  service,
}: {
  service: TicketType;
}): Promise<any> => {
  const { data } = await axios.get(
    `/api/integrations/v2/ticketing/${service}/mapping/`,
  );

  return data;
};

export const fetchIntegrationFieldsByStep = async ({
  step,
  service,
  fieldsData,
}: {
  step: any;
  service: string;
  fieldsData?: any;
}): Promise<any> => {
  const { data } = await axios.post(
    `/api/integrations/v2/ticketing/${service}/mapping/${step}/`,
    fieldsData,
  );

  return data;
};

export const saveIntegrationsWorkflow = async (
  service: TicketType,
): Promise<any> => {
  const { data } = await axios.post(
    `/api/integrations/v2/ticketing/${service}/workflows/`,
  );

  return data;
};

export const createIntegrationTicket = async ({
  risksIds,
  ticketType,
  configuration = [],
}: {
  configuration: any;
  risksIds: string[];
  ticketType: TicketType;
}): Promise<any> => {
  const { data } = await axios.post(
    `/api/integrations/v2/workflows/initiate/${ticketType}/`,
    {
      configuration,
      policies_ids: risksIds,
    },
  );

  return data;
};

export const deleteIntegrationV2 = async (
  integrationId: string,
): Promise<any> => {
  const { data } = await axios.delete(
    `/api/integrations/v2/${integrationId}/delete/`,
  );

  return data;
};

export const validateIntegrationCredentials = async (
  service: string,
  credentials: any,
): Promise<any> => {
  const { data } = await axios.post(
    `/api/integrations/v2/connect/${service}/credentials/validate/`,
    {
      credentials,
    },
  );

  return data;
};

export const createIntegrationV2 = async (
  service: string,
  credentials: any,
): Promise<any> => {
  const { data } = await axios.post(`/api/integrations/v2/${service}/create/`, {
    credentials,
  });

  return data;
};
